module.exports = __webpack_public_path__ + "static/media/blog3.0c36786a.png";